/**
 * Helpers de membership do Kanban Enterprise (espelha o backend).
 */

export const UNASSIGNED_COLUMN_ID = "unassigned";

export const hasActiveFilter = (filterJson) => {
  const f = filterJson || {};
  if (!f || typeof f !== "object") return false;

  if (Array.isArray(f.status) && f.status.length > 0) return true;
  if (Array.isArray(f.queueIds) && f.queueIds.length > 0) return true;
  if (Array.isArray(f.tagIds) && f.tagIds.length > 0) return true;
  if (Array.isArray(f.userIds) && f.userIds.length > 0) return true;
  if (Array.isArray(f.whatsappIds) && f.whatsappIds.length > 0) return true;
  if (Array.isArray(f.priority) && f.priority.length > 0) return true;
  if (f.unreadOnly) return true;
  if (f.noQueue) return true;
  if (f.noUser) return true;

  return false;
};

export const isManualColumn = (column) => {
  if (!column || column.isVirtual) return false;
  const type = String(column.type || "custom").toLowerCase();

  // custom/manual sem filtro ativo: sempre manual (mesmo se membership ficou preso em filter)
  if (
    (type === "custom" || type === "manual") &&
    !hasActiveFilter(column.filterJson)
  ) {
    return true;
  }

  const settings = column.settingsJson || {};
  if (settings.membership === "manual") return true;
  if (settings.membership === "filter") return false;

  if (type === "manual") return true;

  return false;
};

export const boardHasManualColumns = (columns = []) =>
  columns.some((c) => isManualColumn(c));

export const buildUnassignedColumn = () => ({
  id: UNASSIGNED_COLUMN_ID,
  name: "Sem etapa",
  type: "manual",
  color: "#90A4AE",
  isVirtual: true,
  filterJson: {},
  settingsJson: { membership: "manual" },
});
